"use client";
import { rem } from "../../../utils/units-converters/rem.mjs";
import { parseThemeColor } from "../parse-theme-color/parse-theme-color.mjs";
import { isVirtualColor } from "../../MantineCssVariables/virtual-color/virtual-color.mjs";
import { darken } from "../darken/darken.mjs";
import { getGradient } from "../get-gradient/get-gradient.mjs";
import { rgba } from "../rgba/rgba.mjs";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/default-variant-colors-resolver/default-variant-colors-resolver.ts
const defaultVariantColorsResolver = ({ color, theme, variant, gradient, autoContrast }) => {
	const parsed = parseThemeColor({
		color,
		theme
	});
	const _autoContrast = typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast;
	if (variant === "none") return {
		background: "transparent",
		hover: "transparent",
		color: "inherit",
		border: "none"
	};
	if (variant === "filled") {
		const isVirtual = parsed.isThemeColor && parsed.shade === void 0 && isVirtualColor(theme.colors[parsed.color]);
		const textColor = _autoContrast ? isVirtual ? `var(--mantine-color-${parsed.color}-contrast)` : parsed.isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)" : "var(--mantine-color-white)";
		if (parsed.isThemeColor) {
			if (parsed.shade === void 0) return {
				background: `var(--mantine-color-${color}-filled)`,
				hover: `var(--mantine-color-${color}-filled-hover)`,
				color: textColor,
				border: `${rem(1)} solid transparent`
			};
			return {
				background: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
				hover: `var(--mantine-color-${parsed.color}-${parsed.shade === 9 ? 8 : parsed.shade + 1})`,
				color: textColor,
				border: `${rem(1)} solid transparent`
			};
		}
		return {
			background: color,
			hover: darken(color, .1),
			color: textColor,
			border: `${rem(1)} solid transparent`
		};
	}
	if (variant === "light") {
		if (parsed.isThemeColor) {
			if (parsed.shade === void 0) return {
				background: `var(--mantine-color-${color}-light)`,
				hover: `var(--mantine-color-${color}-light-hover)`,
				color: `var(--mantine-color-${color}-light-color)`,
				border: `${rem(1)} solid transparent`
			};
			const parsedColor = theme.colors[parsed.color][parsed.shade];
			return {
				background: parsedColor,
				hover: darken(parsedColor, .1),
				color: `var(--mantine-color-${parsed.color}-light-color)`,
				border: `${rem(1)} solid transparent`
			};
		}
		return {
			background: rgba(color, .1),
			hover: rgba(color, .12),
			color,
			border: `${rem(1)} solid transparent`
		};
	}
	if (variant === "outline") {
		if (parsed.isThemeColor) {
			if (parsed.shade === void 0) return {
				background: "transparent",
				hover: `var(--mantine-color-${color}-outline-hover)`,
				color: `var(--mantine-color-${color}-outline)`,
				border: `${rem(1)} solid var(--mantine-color-${color}-outline)`
			};
			return {
				background: "transparent",
				hover: rgba(theme.colors[parsed.color][parsed.shade], .05),
				color: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
				border: `${rem(1)} solid var(--mantine-color-${parsed.color}-${parsed.shade})`
			};
		}
		return {
			background: "transparent",
			hover: rgba(color, .05),
			color,
			border: `${rem(1)} solid ${color}`
		};
	}
	if (variant === "subtle") {
		if (parsed.isThemeColor) {
			if (parsed.shade === void 0) return {
				background: "transparent",
				hover: `var(--mantine-color-${color}-light-hover)`,
				color: `var(--mantine-color-${color}-light-color)`,
				border: `${rem(1)} solid transparent`
			};
			const parsedColor = theme.colors[parsed.color][parsed.shade];
			return {
				background: "transparent",
				hover: rgba(parsedColor, .12),
				color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
				border: `${rem(1)} solid transparent`
			};
		}
		return {
			background: "transparent",
			hover: rgba(color, .12),
			color,
			border: `${rem(1)} solid transparent`
		};
	}
	if (variant === "transparent") {
		if (parsed.isThemeColor) {
			if (parsed.shade === void 0) return {
				background: "transparent",
				hover: "transparent",
				color: `var(--mantine-color-${color}-light-color)`,
				border: `${rem(1)} solid transparent`
			};
			return {
				background: "transparent",
				hover: "transparent",
				color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
				border: `${rem(1)} solid transparent`
			};
		}
		return {
			background: "transparent",
			hover: "transparent",
			color,
			border: `${rem(1)} solid transparent`
		};
	}
	if (variant === "white") {
		if (parsed.isThemeColor) {
			if (parsed.shade === void 0) return {
				background: "var(--mantine-color-white)",
				hover: darken(theme.white, .01),
				color: `var(--mantine-color-${color}-filled)`,
				border: `${rem(1)} solid transparent`
			};
			return {
				background: "var(--mantine-color-white)",
				hover: darken(theme.white, .01),
				color: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
				border: `${rem(1)} solid transparent`
			};
		}
		return {
			background: "var(--mantine-color-white)",
			hover: darken(theme.white, .01),
			color,
			border: `${rem(1)} solid transparent`
		};
	}
	if (variant === "gradient") return {
		background: getGradient(gradient, theme),
		hover: getGradient(gradient, theme),
		color: "var(--mantine-color-white)",
		border: "none"
	};
	if (variant === "default") return {
		background: "var(--mantine-color-default)",
		hover: "var(--mantine-color-default-hover)",
		color: "var(--mantine-color-default-color)",
		border: `${rem(1)} solid var(--mantine-color-default-border)`
	};
	return {};
};
//#endregion
export { defaultVariantColorsResolver };

//# sourceMappingURL=default-variant-colors-resolver.mjs.map